// src/features/userManagement/userManagement.routes.js
import UserManagementView from './UserManagementView.vue';

const userManagementRoutes = [
  {
    path: '/users-management',
    name: 'UserManagement',
    component: UserManagementView,
    meta: {
      requiresAuth: true, // This route requires authentication
      layout: 'AppLayout', // Assuming a main layout like AppLayout
    },
  },
];

export default userManagementRoutes;
